import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { db } from "helpers/firebase/firebaseConfig";
import { onSnapshot, collection } from "firebase/firestore";
import { fetchOrdersRequest, fetchServiceProviderRequestsRequest, fetchTransactions } from "../../store/actions";
import { toast } from 'react-toastify';

// Collection names
const ORDERS_COLLECTION = "Booking";
const JOIN_REQUEST_COLLECTION = "service_provider_join_requests";
const INVOICES_COLLECTION = "service_provider_sale_invoices";

const OrderSubscription = ({ children }) => {
  const dispatch = useDispatch();

    // Audio reference
  const audioRef = useRef(null);

  useEffect(() => {
    // Subscribe to orders collection changes
        // Prepare audio element
    audioRef.current = new Audio("/notification.mp3");


    const unsubscribeOrders = onSnapshot(
      collection(db, ORDERS_COLLECTION),
      (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            handleCreateEvent();
          } else if (change.type === "modified") {
            handleOrderUpdateEvent();
          }
        });
      },
      (error) => {
        console.error("Orders subscription error:", error);
      }
    );

    // Subscribe to join requests collection changes
    const unsubscribeJoinRequest = onSnapshot(
      collection(db, JOIN_REQUEST_COLLECTION),
      (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            handleJoinRequestCreateEvent();
          }
        });
      },
      (error) => {
        console.error("Join requests subscription error:", error);
      }
    );

    // Subscribe to invoices collection changes
    const unsubscribeInvoices = onSnapshot(
      collection(db, INVOICES_COLLECTION),
      (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            handleInvoices();
          } else if (change.type === "modified") {
            handleInvoices();
          } else if (change.type === "removed") {
            handleInvoices();
          } 
        });
      },
      (error) => {
        console.error("Invoices subscription error:", error);
      }
    );

    // Cleanup the subscriptions when the component unmounts
    return () => {
      unsubscribeOrders();
      unsubscribeJoinRequest();
      unsubscribeInvoices();
    };
  }, [dispatch]);

  const handleCreateEvent = () => {
    dispatch(fetchOrdersRequest());
        audioRef.current?.play().catch(err => console.error("Audio play failed:", err));

    // toast.info('📢 تم حجز طلب جديد! يرجى مراجعة التفاصيل.', {
    //   position: "top-right",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: false,
    //   draggable: false,
    //   progress: undefined,
    // });
  };

  const handleJoinRequestCreateEvent = () => {
    dispatch(fetchServiceProviderRequestsRequest());
        // Play sound
    // audioRef.current?.play().catch(err => console.error("Audio play failed:", err));

    // toast.info('📢 تم تقديم طلب انضمام جديد! يرجى اتخاذ الإجراء اللازم.', {
    //   position: "top-right",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    // });
  };

  const handleInvoices = () => {
    dispatch(fetchTransactions());
  };

  const handleOrderUpdateEvent = () => {
            // audioRef.current?.play().catch(err => console.error("Audio play failed:", err));
    dispatch(fetchOrdersRequest());
    // toast.info('📝 تم تحديث حالة طلب!', {
    //   position: "top-right",
    //   autoClose: 3000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: false,
    //   draggable: false,
    // });
  };



  return children;
};

export default OrderSubscription;